import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Alert } from '@ublend-npm/aulaui-next';

import { FormWrapper } from '../FormWrapper';

import {
  TextField,
  Title,
  AlertContainer,
  TextfieldContainer,
  SubmitContainer,
  SignupButtonContainer,
} from '../FormWrapper.styled';

import { SpaceCodeSchema } from '../../../utils/validationSchemas';
import { SpaceCodeFields } from '../FormWrapper.types';
import { errorMessages } from '../../../utils/errorMessages';

type SpaceCodeValidationStepProps = {
  onSubmit: (data: SpaceCodeFields) => void;
  spaceCode?: string;
  loading?: boolean;
  error?: boolean | null;
};

export const SpaceCodeValidationStep = ({
  onSubmit,
  error,
  loading,
  spaceCode,
}: SpaceCodeValidationStepProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SpaceCodeFields>({
    resolver: yupResolver(SpaceCodeSchema),
  });

  return (
    <FormWrapper>
      <Title>Enter the code to sign up:</Title>
      <TextfieldContainer>
        <TextField
          {...register('spaceCode', { required: true })}
          id="signup-form-space-code"
          label="6-character code"
          defaultValue={spaceCode}
          error={!!errors.spaceCode}
          helperText={errors.spaceCode?.message}
          disabled={loading}
        />
      </TextfieldContainer>
      <SubmitContainer>
        {error && (
          <AlertContainer>
            <Alert type="error">{errorMessages.SPACE_CODE_ERROR}</Alert>
          </AlertContainer>
        )}
        <SignupButtonContainer>
          <Button
            id="signup-button"
            type="primary"
            onClick={handleSubmit((data: SpaceCodeFields) => onSubmit(data))}
            aria-label="Next"
            loading={loading}
          >
            Next
          </Button>
        </SignupButtonContainer>
      </SubmitContainer>
    </FormWrapper>
  );
};
